<template>
  <div class="layout_container">
    <div class="headerTop top is-print-hide" v-if="showHomeTop">
      <home-header :company="userName"></home-header>
    </div>
    <!-- <Warn></Warn> -->
    <notification></notification>
    <div :class="renderRouterCls()">
      <Menu v-show="!hideMenu"></Menu>
      <div class="scroller">
        <Banner v-if="isSupervisionRoute" />
        <!-- <tag-view></tag-view> -->
        <!-- 系统横幅通知 -->
        <div class="system-banner" v-if="bannerConfig.text && bannerConfig.visible">
          <div class="banner-container">
            <div class="banner-content">
              <i class="el-icon-info banner-icon"></i>
              <div class="banner-text-wrapper" ref="bannerWrapper">
                <div class="banner-text" :class="{ scrolling: bannerConfig.autoScroll }" ref="bannerText">
                  <template v-if="bannerConfig.autoScroll">
                    <!-- 动态生成足够多的副本确保无缝滚动 -->
                    <span v-for="index in bannerRepeatCount" :key="index" class="banner-text-item">
                      {{ bannerConfig.text }}
                    </span>
                  </template>
                  <template v-else>
                    {{ bannerConfig.text }}
                  </template>
                </div>
              </div>
              <i v-if="bannerConfig.closable" class="el-icon-close banner-close" @click="closeBanner"></i>
            </div>
          </div>
        </div>

        <!-- 系统通知弹窗 -->
        <el-dialog
          :visible.sync="showBannerDialog"
          width="500px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          center
          custom-class="banner-dialog"
        >
          <div
            slot="title"
            class="dialog-title-with-icon"
            style="display: flex; align-items: center; justify-content: center"
          >
            <i class="el-icon-bell" style="color: #dc2626; font-size: 30px; margin-right: 8px"></i>
            <span style="font-size: 18px; font-weight: bold">{{ bannerConfig.modalTitle }}</span>
          </div>

          <div class="banner-dialog-content">
            <div class="dialog-text">
              {{ bannerConfig.text }}
            </div>
          </div>
          <div class="banner-dialog-content code-img" v-show="bannerConfig.renewalQrCodeUrl">
            <img :src="bannerConfig.renewalQrCodeUrl" alt="" />
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeBannerDialog" type="primary">知道了</el-button>
          </div>
        </el-dialog>

        <transition name="fade-transform" mode="out-in">
          <keep-alive :include="cachedViews">
            <router-view></router-view>
          </keep-alive>
        </transition>
      </div>
    </div>
    <agreement-modal />

    <select-drug-modal />
    <activityOverlay v-if="showActivity && pcDialogShow">
      <div class="img-box">
        <img :src="pcDialog[0].imgUrl" alt="" @click="goActivity(pcDialog[0])" />
        <i class="overlay-close el-icon-circle-close" @click.prevent.stop="handleClose"></i>
        <div class="click-area" @click="goActivity(pcDialog[0])"></div>
      </div>
    </activityOverlay>
    <explorerGuideModal />
    <addressModal />
    <rtcVideo></rtcVideo>
  </div>
</template>
<script>
import homeHeader from '@/components/global/headerNew.vue';
import Menu from '@/components/menuNew/index.vue';
import { getDevHost, runWhenIdle, Util } from '@/util';
import notification from '@/components/global/notification';
import agreementModal from './modals/agreementModal';
import classnames from 'classnames';
import explorerGuideModal from './modals/explorerGuideModal';
import activityOverlay from '@/components/activity/activityOverlay.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import selectDrugModal from './modals/selectDrugModal';
import addressModal from './modals/addressModal';
// import zim, { zimApi, emojis, tools, GuideDiagnosisClass } from '@zyf2e/zim/lib/drugPlatform';
import Banner from './banner.vue';
// import { registerModule as registerVideoModule } from '@zyf2e/video-service-ecology/lib/videoStore'
import store from '@/store';
import Vue from 'vue';

import { rtcVideo } from '@zyf2e/video-service-ecology/lib/video.js';

import { registerModule } from '@zyf2e/zim-ecology/lib/pcstore';
import { DragVideoDirective, registerModule as registerVideoModule } from '@zyf2e/video-service-ecology/lib/videoStore';

//import { DragVideoDirective } from '@zyf2e/video-service-ecology/lib/videoStore';
// import { registerModule } from '@zyf2e/zim-ecology/lib/pcstore'
// import NETEASEv1 from '@zyf2e/rtcpc/lib/nertcv1-service';
// import TRTC from '@zyf2e/rtcpc/lib/trtc-service';
// import videoService, {
//   videoServiceApi,
//   VIDEO_SERVICE_EVENT,
//   videoSdkEvent,
//   sdkLog
// } from '@zyf2e/rtcpc/lib/video-service';

Vue.directive('drag', DragVideoDirective);

registerVideoModule(store);

registerModule(store);

export default {
  name: 'app',
  data() {
    return {
      tabItems: [],
      showHomeTop: true,
      company: '',
      hideMenu: false, // 隐藏菜单栏布局
      showActivity: true, // 满足活动的用户
      bannerRepeatCount: 3 // 默认重复3次
    };
  },

  computed: {
    ...mapState('global', ['storeInfo', 'bannerConfig']),
    ...mapGetters(['supervision_routes']),
    keepAlive() {
      return this.$store.getters.keepAlive;
    },
    userName() {
      return this.$store.getters.userName;
    },
    cachedViews() {
      return this.$store.getters.cachedViews;
    },
    userId() {
      return this.$store.getters.userId;
    },
    ucUserId() {
      return this.$store.getters.ucUserId;
    },
    isSupervisionRoute() {
      let bol = false;
      const { path } = this.$route;
      if (this.supervision_routes) {
        this.supervision_routes.map(item => {
          if (item?.children) {
            item.children.map(i => {
              if (i.path == path) {
                bol = true;
              }
            });
          } else {
            if (item.path == path) {
              bol = true;
            }
          }
        });
      }
      console.log(bol);

      return bol;
    },
    // pc弹窗活动
    pcDialog() {
      const { resourcePutObj } = this.$store.getters;
      const RESOURCE_TYPE = 'PC_DIALOG';
      if (resourcePutObj[RESOURCE_TYPE]) return resourcePutObj[RESOURCE_TYPE];
      return [];
    },
    // pc活动弹窗是否展示
    pcDialogShow() {
      const { pcDialog } = this;
      if (pcDialog.length) {
        const { id } = pcDialog[0];
      }
      if (pcDialog.length) {
        Telescope.trackEvent({
          trackId: 'zywzpc-click-popscreen-b'
        });
      }

      return !!pcDialog.length;
    },
    // 弹窗显示条件
    showBannerDialog() {
      return (
        !this.bannerConfig.todayToast &&
        this.bannerConfig.visible &&
        this.bannerConfig.text &&
        this.bannerConfig.text.trim() !== ''
      );
    }
  },
  methods: {
    ...mapActions('activity', ['getResourcePut']),

    /**
     * 关闭弹窗
     */
    closeBannerDialog() {
      console.log('closeBannerDialog');

      this.$store.commit('global/SET_BANNER_CONFIG', {
        ...this.bannerConfig,
        todayToast: true
      });
    },

    /**
     * 检查文本是否需要滚动
     */
    checkTextScrolling() {
      this.$nextTick(() => {
        const bannerTextEl = this.$refs.bannerText;
        const bannerWrapperEl = this.$refs.bannerWrapper;

        if (bannerTextEl && bannerWrapperEl) {
          // 先测量单个文本的宽度
          const tempSpan = document.createElement('span');
          tempSpan.style.visibility = 'hidden';
          tempSpan.style.position = 'absolute';
          tempSpan.style.fontSize = '13px';
          tempSpan.style.fontWeight = '500';
          tempSpan.style.whiteSpace = 'nowrap';
          tempSpan.textContent = this.bannerConfig.text;
          document.body.appendChild(tempSpan);

          const singleTextWidth = tempSpan.offsetWidth;
          const wrapperWidth = bannerWrapperEl.clientWidth;

          document.body.removeChild(tempSpan);

          const needScroll = singleTextWidth > wrapperWidth;

          if (needScroll) {
            // 计算需要重复多少次才能保证无缝滚动
            // 至少需要足够填满容器宽度的3倍
            const minRepeatCount = Math.ceil((wrapperWidth * 3) / (singleTextWidth + 50)) + 1;
            this.bannerRepeatCount = Math.max(3, minRepeatCount);
          }

          // 更新 store 中的滚动状态
          this.$store.commit('global/SET_BANNER_CONFIG', {
            ...this.bannerConfig,
            autoScroll: needScroll
          });
        }
      });
    },

    connectIm() {
      console.log('connectIm');
      import(/* webpackChunkName:'zim' */ '@zyf2e/zim/lib/drugPlatform').then(
        ({ default: zim, zimApi, emojis, tools, GuideDiagnosisClass }) => {
          const uid = this.ucUserId;
          this.$store.dispatch('imInquiryService/SET_guideDiagnosis', GuideDiagnosisClass);
          this.$store.dispatch('imService/setZIMLib', {
            zim,
            zimApi,
            emojis,
            tools
          });

          this.$store.commit('imDebugService/setDebug', true);
          const zimEnvConfig = {
            uid,
            runtime: {
              env: 'H5',
              apigw: Util.getEnv().toUpperCase()
            },
            debug: false,
            db: true,
            // zone: 'unread-msg.',
            clientInfo: 'PC',
            zone: getDevHost()
          };
          this.$store.commit('imService/SET_ZimConfig', {
            ...zimEnvConfig
          });
          this.$store.dispatch('imService/initIm', {
            uid
          });
          store.dispatch('messageCenter/GetmessageCenterNotification');
          zim.Listener.subscribe('onCustomBusiness', (tag, data) => {
            console.log(tag, data);
            if (data.eventType == 'USER_UNREAD_MESSAGE') {
              //消息中心有新的未读消息
              store.dispatch('messageCenter/GetmessageCenterNotification');
            }
          });
        }
      );
    },
    renderRouterCls() {
      return classnames({
        router_container: true,
        hideMenu: this.hideMenu
      });
    },

    handleClose() {
      this.showActivity = false;
    },
    goActivity({ linkUrl, id }) {
      if (!linkUrl) return;
      const { companyName, companyId, isChain, ucUserId, roleListFromBk, mobile } = this.$store.state.global;
      Telescope.trackEvent({
        trackId: 'zywzpc-click-popscreen-d',
        custom: {
          companyId,
          companyName,
          userId: ucUserId,
          mobile,
          isChain,
          roleList: roleListFromBk,
          time: new Date().getTime()
        }
      });
      // 待参数给跳转页面
      let query =
        linkUrl.indexOf(location.origin) >= 0 ? 'resourceType=PC_DIALOG' : `userId=${ucUserId}&resourceType=PC_DIALOG`;
      query = linkUrl.indexOf('?') > -1 ? `&${query}` : `?${query}`;
      linkUrl = `${linkUrl}${query}`;
      window.open(linkUrl);
      this.showActivity = false;
    },
    initRtcLerna() {
      this.initHookEvent();
      this.zysdkInit();
    },
    initHookEvent() {
      import(/* webpackChunkName:'zim' */ '@zyf2e/rtcpc/lib/video-service').then(({ default: videoService }) => {
        videoService._hooks.onInitDone.tap('onInitDone', data => {
          // const { roleListFromBk } = this.$store.state.global;
          // const code = 'remote_trial_pharmacist';
          this.loginNERTCAccount();
          this.loginVolcAccount();
          // const el = roleListFromBk.find(el => el.code == code);
          // if (el && el.code) {
          // 加个逻辑 远程药师也登录下腾讯
          // this.loginTRTCAccount();
          // }
        });
        videoService._hooks.onChannelLoginSuccess.tap('onChannelLoginSuccess', async data => {
          console.log('渠道登陆成功');
          // const result = await videoService.requestMediaPermission();

          // if (result.success) {
          //   // 摄像头和麦克风都授权成功
          //   console.log('全部授权成功');
          // } else {
          //   console.log('授权失败', result.error);
          // }
        });
        // videoService._hooks.onCallTargetReject.tap('onCallTargetReject', data => {
        //   this.$message({
        //     message: '对方暂时无法接听',
        //     type: 'warning'
        //   });
        // });
      });
    },
    loginVolcAccount() {
      // TODO: 实现火山渠道登陆逻辑
      this.$store.dispatch('video_volc/loginHuoshanAccount', {});
    },
    loginNERTCAccount() {
      this.$store.dispatch('video_nertcv1/loginNERTCV1Account', {});
    },
    loginTRTCAccount() {
      this.$store.dispatch('video_trtcVideoStore/loginTRTCAccount', {});
    },
    zysdkInit() {
      console.log('zysdkInit');

      Promise.all([
        import(/* webpackChunkName:'zim' */ '@zyf2e/rtcpc/lib/video-service'),
        import(/* webpackChunkName:'zim' */ '@zyf2e/rtcpc/lib/trtc-service'),
        import(/* webpackChunkName:'zim' */ '@zyf2e/rtcpc/lib/volc-service'),
        import(/* webpackChunkName:'zim' */ '@zyf2e/rtcpc/lib/nertcv1-service')
      ]).then(result => {
        console.log('##result', result);
        const [
          { default: videoService, videoServiceApi, VIDEO_SERVICE_EVENT, videoSdkEvent, sdkLog },
          { default: TRTC },
          { default: VOLC },
          { default: NETEASEv1 }
        ] = result;
        const {
          TRTC: trtcAppid,
          NERTCV1APPID,
          bizId,
          appId,
          VIDEO_ZONE,
          apigw,
          volcSdkAppID
        } = JSON.parse(process.env.VUE_APP_VIDEO_SDK);
        const param = {
          userId: this.ucUserId,
          bizId,
          appId,
          apigw,
          timeout: 60,
          business: {},
          channelType: 'DPA-PC',
          sdkAppIDObject: {
            trtcSdkAppID: trtcAppid,
            nertcv1SdkAppID: NERTCV1APPID,
            volcSdkAppID
          },
          zone: '',
          scene: '',
          sdkLib: {
            videoService,
            videoServiceApi,
            VIDEO_SERVICE_EVENT,
            videoSdkEvent,
            TRTC,
            NETEASEv1,
            VOLC,
            sdkLog
          },
          debug: process.env.VUE_APP_SDK_ENV === 'QA' ? true : false
          // debug: false
        };
        this.$store.dispatch('video_controller/zyRtcInit', param);
        if (process.env.VUE_APP_SDK_ENV === 'QA') {
          this.$store.dispatch('video_rtcui/openChannelStatus');
        }
      });
    }
  },
  created() {
    this.getResourcePut();
    this.$store.dispatch('prescription/contactStoreVideo');
  },

  mounted() {
    // 检查今日是否已关闭弹窗
    const today = new Date().toDateString();
    const closedDate = localStorage.getItem('banner-dialog-closed-date');
    if (closedDate === today) {
      this.$store.commit('global/SET_BANNER_CONFIG', {
        ...this.bannerConfig,
        todayToast: true
      });
    }

    // 检查是否已关闭横幅
    const bannerClosed = localStorage.getItem('system-banner-closed');
    if (bannerClosed === 'true') {
      this.$store.commit('global/SET_BANNER_VISIBLE', false);
    }

    // 检查横幅文本是否需要滚动
    if (this.bannerConfig.text && this.bannerConfig.visible) {
      this.checkTextScrolling();
    }

    // 监听窗口大小变化，重新检查是否需要滚动
    window.addEventListener('resize', this.checkTextScrolling);
    this.$store.dispatch('global/getPackageRenewalNotify');
    this.$store.dispatch('messageSupervision/haveMessage');
    runWhenIdle(() => {
      this.connectIm();
      this.initRtcLerna();
    });
  },

  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('resize', this.checkTextScrolling);
  },
  watch: {
    $route: {
      handler() {
        // 后期可能有需要隐藏菜单栏的路由 同时修正布局 已经做好备用
        /* if (this.$route.name == 'messageCenter') {
          this.hideMenu = true;
        } else {
          this.hideMenu = false;
        } */
      },
      immediate: true
    }
  },
  components: {
    homeHeader,
    Menu,
    Banner,
    notification,
    agreementModal,
    activityOverlay,
    explorerGuideModal,
    selectDrugModal,
    addressModal,
    rtcVideo
  }
};
</script>

<style lang="scss" scope>
.layout_container {
  height: 100%;
}
.top {
  background: #fff;
}
.router_container {
  // padding: 100px 40px 50px;
  padding-top: 48px;
  // min-width: 1200px;
  // min-width: 1148px;
  min-width: 1024px;
  margin: 0 auto;
  height: 100%;
  .scroller {
    // float: left;
    // max-width: 100px;
    min-width: 784px;
    overflow: scroll;
    height: 100%;
    position: relative;
    // min-height: calc(100vh - 48px);
    // height: 100%;
    // padding-left: 240px;
    padding-left: 216px;
    padding-top: 18px;
    padding-right: 16px;
    background: #f5f5f5;
    padding-bottom: 20px;
  }
}
.hideMenu {
  .scroller {
    // float: left;
    // max-width: 100px;
    min-width: 784px;
    overflow: scroll;
    height: 100%;

    padding-left: 0px;
    // padding-left: 256px;
    padding-top: 18px;
    padding-right: 16px;
    background: #fafafa;
    padding-bottom: 20px;
  }
}

@media print {
  //打印特殊处理一下布局
  .router_container {
    padding-top: 0 !important;
    min-width: auto !important;
    margin: 0 !important;
    height: auto !important;
    .scroller {
      padding: 0;
      min-width: auto !important;
      overflow: auto !important;
      height: auto !important;
      padding: 0 !important;
      background: #ffffff !important;
    }
  }
}
</style>
<style lang="scss" scoped>
// 系统横幅样式 - 白色背景 + 红色文字
.system-banner {
  margin-bottom: 10px;
  // position: sticky;
  position: relative;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  border-left: 4px solid #dc2626;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  .banner-container {
    max-width: 1200px;
    // margin: 0 auto;

    .banner-content {
      display: flex;
      align-items: center;
      padding: 8px 20px;
      color: #dc2626;
      position: relative;

      .banner-icon {
        font-size: 16px;
        margin-right: 8px;
        flex-shrink: 0;
        color: #dc2626;
      }

      .banner-text-wrapper {
        flex: 1;
        overflow: hidden;
        margin-right: 12px;

        .banner-text {
          font-size: 13px;
          line-height: 1.4;
          font-weight: 500;
          color: #dc2626;
          white-space: nowrap;
          display: flex;

          &.scrolling {
            animation: seamless-scroll 15s linear infinite;
            width: max-content;

            .banner-text-item {
              margin-right: 50px; // 两个文本之间的间距
            }
          }

          &:not(.scrolling) {
            white-space: normal;
            word-wrap: break-word;
          }
        }
      }

      .banner-close {
        font-size: 14px;
        cursor: pointer;
        flex-shrink: 0;
        opacity: 0.7;
        transition: opacity 0.2s;
        color: #dc2626;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

// 滚动动画 - 默认居左显示然后滚动
@keyframes scroll-banner {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

// 无缝滚动动画 - 移动一个文本的距离
@keyframes seamless-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% / var(--repeat-count, 3)));
  }
}

.headerTop {
  position: fixed;
  width: 100%;
  z-index: 10;
}

.img-box {
  width: 378px;
  margin: 200px auto 100px auto;
  position: relative;
  .overlay-close {
    position: absolute;
    top: -30px;
    right: -40px;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }
  img {
    width: 100%;
  }
  .click-area {
    position: absolute;
    margin: 0 auto;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 60px;
    cursor: pointer;
  }
}

::v-deep .banner-dialog .el-dialog__header .el-dialog__title::before {
  content: '\e6a3'; // el-icon-bell的unicode
  font-family: element-icons;
  color: #dc2626;
  font-size: 20px;
  margin-right: 8px;
}
::v-deep .banner-dialog .el-dialog__body {
  .code-img {
    img {
      display: block;
      width: 200px;
      height: 200px;
      margin: 10px auto;
    }
  }
}
</style>
